import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getPatientImmunizationsSelector } from '../selectors'
import { performWithMutexHOG } from '../../../services/mutexUtility.service'
import { PcrDocsService } from '../../../services/pcrDocs.service'
import { getPcrIdSelector } from '../../home/selectors'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { IPcr } from '../../pcr/store/pcr.types'
import { getServiceIdSelector } from '../../user/selectors'
import { PatientImmunizationsConstants } from '../store/patientImmunizations.constants'
import { IPatientImmunizationsState } from '../store/patientImmunizations.types'
import { initialPatientImmunization } from '../store/patientImmunizations.reducers'

export function* saveImmunization() {
  const immunizationState: IPatientImmunizationsState = yield select(getPatientImmunizationsSelector)
  const serviceId: string = yield select(getServiceIdSelector)
  const pcrID: string = yield select(getPcrIdSelector)
  if (pcrID) {
    const pcrDocsService = new PcrDocsService(serviceId)
    const pcrDoc: IPcr = yield call([pcrDocsService, pcrDocsService.getPCR], pcrID)

    const newImmunizations = immunizationState.immunizations.filter(
      (immune) => immune.immunizationType !== null && immune.year !== initialPatientImmunization().year
    )

    const pcrDocUpdated: IPcr = {
      ...pcrDoc,
      patient: {
        ...pcrDoc.patient,
        patientImmunizations: { ...immunizationState, immunizations: newImmunizations },
      },
    }
    try {
      yield call([pcrDocsService, pcrDocsService.savePCR], pcrDocUpdated)
    } catch (e) {
      yield put(throwPcrException(`saveImmunization() error: ${e}`))
    }
  } else {
    // todo: add to audit log
  }
}

export function* saveImmunizationSaga() {
  yield takeLatest(
    [
      PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATION_TYPE,
      PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_STATUS,
      PatientImmunizationsConstants.SET_PATIENT_IMMUNIZATIONS_INCOMPLETE_REASON,
      PatientImmunizationsConstants.REMOVE_PATIENT_IMMUNIZATION,
      PatientImmunizationsConstants.SAVE_IMMUNIZATION,
    ],
    performWithMutexHOG,
    saveImmunization
  )
}
